import React from 'react'
import DateInputCustom from './DateInputCustom'
import {InputCustomPropsWithDetailsModel} from "../models/InputCustomPropsModel";
import {toEnDateString} from "../../../utils/dateUtils";

const InputCustomDate = ({
                             changeValue,
                             type,
                             name,
                             classString,
                             error,
                             value,
                             extra = {},

                             ...rest
                         }: InputCustomPropsWithDetailsModel) => {
    const isIsoString = extra?.formatIsoString;
    const changeValueHandler = (data: any, event : any) => {
        const format = isIsoString? new Date(data).toISOString() : data;
        changeValue(format, event)
    }
    const formatToIsoString = (v: any) => {
        return v ? toEnDateString(v) : v
    }
    return (
        <>
            <DateInputCustom
                error={error}
                name={name}
                value={isIsoString? formatToIsoString(value) : value}
                changeValue={changeValueHandler}
                {...rest}
            />
        </>
    )
}

export default InputCustomDate
